var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallDog = function SvgSmallDog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.5v6.75H6S6.75 18 8.25 18h4.5c1.5 0 2.25 2.25 2.25 2.25h2.25V18a9.855 9.855 0 0 0 2.25-6.75l3.75-.75V8.25C22.5 6 18 5.25 18 5.25L16.5 3s-2.25.75-2.25 2.25-.75 4.5-2.25 4.5H3.75c-2.25 0-3 2.25-3 3.75v3.75",
    stroke: "#484848",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSmallDog;